import React from 'react';
import { VehicleIdentity } from '../logic/identityEngine';

interface VIGConfirmationModalProps {
    identity: VehicleIdentity;
    onConfirm: () => void;
    onCancel: () => void;
    isOpen: boolean;
}

export const VIGConfirmationModal: React.FC<VIGConfirmationModalProps> = ({
    identity,
    onConfirm,
    onCancel,
    isOpen
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[100] bg-black/90 backdrop-blur-md flex items-center justify-center p-4 animate-in fade-in duration-300">
            <div className="bg-charcoal-dark border border-white/10 rounded-3xl p-6 w-full max-w-md shadow-2xl relative overflow-hidden">
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-primary to-transparent opacity-50"></div>

                <div className="flex flex-col items-center mb-6 text-center">
                    <div className="size-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-4 border border-primary/20">
                        <span className="material-symbols-outlined text-primary text-3xl">directions_car</span>
                    </div>
                    <h3 className="text-xl font-bold text-white mb-1">تأكيد هوية السيارة</h3>
                    <p className="text-xs text-gray-400">يا هندسة، أتأكد من البيانات دي صحيحة عشان التشخيص يطلع مظبوط</p>
                </div>

                <div className="bg-white/5 rounded-2xl p-4 border border-white/5 space-y-3 mb-6">
                    <div className="flex justify-between items-center text-sm">
                        <span className="text-gray-500">الماركة:</span>
                        <span className="text-white font-bold">{identity.make}</span>
                    </div>
                    <div className="flex justify-between items-center text-sm">
                        <span className="text-gray-500">الموديل:</span>
                        <span className="text-white font-bold">{identity.model}</span>
                    </div>
                    <div className="flex justify-between items-center text-sm">
                        <span className="text-gray-500">السنة:</span>
                        <span className="text-white font-bold">{identity.year}</span>
                    </div>
                    <div className="flex justify-between items-center text-sm">
                        <span className="text-gray-500">المحرك:</span>
                        <span className="text-white font-bold">{identity.engine}</span>
                    </div>
                    {identity.vin && (
                        <div className="flex justify-between items-center text-sm">
                            <span className="text-gray-500">رقم الشاسي:</span>
                            <span className="text-white font-mono text-xs">{identity.vin}</span>
                        </div>
                    )}
                </div>

                {identity.confidence_score < 70 && (
                    <div className="bg-yellow-500/10 border border-yellow-500/20 rounded-xl p-3 mb-6 flex gap-3">
                        <span className="material-symbols-outlined text-yellow-500">warning</span>
                        <p className="text-[10px] text-yellow-500 leading-relaxed font-bold">
                            ملاحظة: البيانات دي تم استخراجها من الوصف، لو في حاجة غلط عدلها قبل ما تبدأ.
                        </p>
                    </div>
                )}

                <div className="flex gap-3">
                    <button
                        onClick={onCancel}
                        className="flex-1 py-3.5 rounded-xl bg-white/5 hover:bg-white/10 text-gray-400 text-sm font-bold transition-colors"
                    >
                        تعديل
                    </button>
                    <button
                        onClick={onConfirm}
                        className="flex-1 py-3.5 rounded-xl bg-primary text-background-dark text-sm font-bold shadow-lg shadow-primary/20 hover:bg-primary/90 transition-all"
                    >
                        تأكيد السيارة
                    </button>
                </div>
            </div>
        </div>
    );
};
